module.exports = __webpack_public_path__ + "static/media/x-button-blue.bff72670.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/x-button-blue.svg
// module id = 813
// module chunks = 0